import { DEFAULT_FORMAT_FALLBACK, FORMAT_PART_SEPARATOR } from './constants';
import { formatCurrency } from './formatCurrency';
import { formatNumber, resolveNumberValue } from './formatNumber';
import { FormatMoneyOptions } from './types';

const resolveMoneyMinimumFractionDigits = (
  value: number,
  maximumFractionDigits: number,
  minimumFractionDigits?: number
): number | undefined => {
  if (minimumFractionDigits !== undefined) return minimumFractionDigits;

  const roundedValue = Number(value.toFixed(maximumFractionDigits));

  return Number.isInteger(roundedValue) ? undefined : maximumFractionDigits;
};

export const formatMoney = (options: FormatMoneyOptions): string => {
  const {
    currency,
    fallback = DEFAULT_FORMAT_FALLBACK,
    maximumFractionDigits = 2,
    minimumFractionDigits,
    signed = false,
    value
  } = options;

  const numberValue = resolveNumberValue(value);

  if (numberValue === null) return fallback;

  const currencyValue = currency?.trim() ?? '';
  const currencyLabel = currencyValue ? formatCurrency({ value: currencyValue }) : '';
  const sign = numberValue < 0 ? '−' : signed && numberValue > 0 ? '+' : '';
  const absoluteValue = Math.abs(numberValue);
  const formattedValue = formatNumber({
    fallback,
    maximumFractionDigits,
    minimumFractionDigits: resolveMoneyMinimumFractionDigits(
      absoluteValue,
      maximumFractionDigits,
      minimumFractionDigits
    ),
    value: absoluteValue
  });

  return `${sign}${formattedValue}${currencyLabel ? `${FORMAT_PART_SEPARATOR}${currencyLabel}` : ''}`;
};